import utils from "../../utils";
import CustomIcon from "../CustomIcon";

import React, { useContext } from "react";


import Cookies from "js-cookie";
import constants from "../../values/constants";
import Context from "../../context";
import { useTranslation } from "react-i18next";

import "./index.scss";

interface Props {
  deptCopanies2Admin     ?: string;
  paidTransactionCompany ?: string;
  transactionOnlineParent?: string;
  deptCompany2Admin  ?: string;
  deptCompany2Drivers?: string;
}

const SecondaryWallet: React.FC<Props> = (props: Props): React.ReactElement => {
  const userType: string = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  const { userInfo } = useContext(Context.UserScreen);

  const { t } = useTranslation();

  console.log(props)

  return (
    <div id='secondary-wallet-container'>
      {props?.paidTransactionCompany &&
        ((userType === "ADMIN" && userInfo?.isPrimary) && (
          <div className="admin-wallet-wrapper">
            <div className='wallet-amount-and-icon-wrapper'>
              <CustomIcon icon="fas fa-usd" hoverTitle={'بدهکاری به ادمین'} type="seconday"/>
              <span>
                {utils.convertNumberToPrice(Math.floor(Number(props?.deptCompany2Admin as string)))} {t("toman")}
              </span>
            </div>
            <div className='wallet-amount-and-icon-wrapper'>
              <CustomIcon icon="fas fa-usd" hoverTitle={'مجموع بدهکاری به راننده‌ها'} type="seconday"/>
              <span>
                {utils.convertNumberToPrice(Math.floor(Number(props?.deptCompany2Drivers as string)))} {t("toman")}
              </span>
            </div>
            <div className='wallet-amount-and-icon-wrapper'>
              <CustomIcon icon="fas fa-usd" hoverTitle={'پردختیهای اولیاء'} type="seconday"/>
              <span>
                {utils.convertNumberToPrice(Math.floor(Number(props?.transactionOnlineParent as string)))} {t("toman")}
              </span>
            </div>
          </div>
        ))}

      {/* ========================================================================================================== */}
      {/* ========================================================================================================== */}

      {userType === "COMPANY" && (
        <div className="admin-wallet-wrapper">
          <div className='wallet-amount-and-icon-wrapper'>
            <CustomIcon icon="fas fa-usd" hoverTitle={'مجموع بدهکاری از شرکت ها'} type="seconday"/>
            <span>
                {utils.convertNumberToPrice(Math.floor(Number(props?.deptCopanies2Admin as string)))} {t("toman")}
              </span>
          </div>
          <div className='wallet-amount-and-icon-wrapper'>
            <CustomIcon icon="fas fa-usd" hoverTitle={'مجموع بدهکاری به شرکت ها'} type="seconday"/>
            <span>
                {utils.convertNumberToPrice(Math.floor(Number(props?.paidTransactionCompany as string)))} {t("toman")}
              </span>
          </div>
          <div className='wallet-amount-and-icon-wrapper'>
            <CustomIcon icon="fas fa-usd" hoverTitle={'پردختیهای اولیاء'} type="seconday"/>
            <span>
                {utils.convertNumberToPrice(Math.floor(Number(props?.transactionOnlineParent as string)))} {t("toman")}
              </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecondaryWallet;
